import { LinearProgress, styled } from '@mui/material'
import { colors } from 'constants/theme'
import { useHero } from '../WidgetCard/HeroContext'

const StyledProgress = styled(LinearProgress, {
  shouldForwardProp: (prop) => prop !== 'achievedPercent' && prop !== 'onHero',
})<{ achievedPercent: number; onHero: boolean }>(({ theme, achievedPercent, onHero }) => ({
  height: 8,
  borderRadius: 4,
  backgroundColor: onHero ? colors.white30 : theme.palette.action.hover,
  '.MuiLinearProgress-bar': {
    borderRadius: 4,
    backgroundColor: onHero
      ? colors.white
      : achievedPercent >= 100
      ? theme.palette.success.main
      : achievedPercent >= 70
      ? theme.palette.warning.main
      : theme.palette.error.main,
  },
}))

export default function KPIProgress({ achievedPercent }: { achievedPercent: number | null }) {
  const { onHero } = useHero()
  if (achievedPercent == null) {
    return <StyledProgress variant="determinate" value={0} achievedPercent={0} onHero={onHero} />
  }
  const clamped = Math.min(100, Math.max(0, achievedPercent))
  return <StyledProgress variant="determinate" value={clamped} achievedPercent={achievedPercent} onHero={onHero} />
}
